module.exports = __webpack_public_path__ + "PinkNannies-Circle.svg?482c6488458464a033de43744b433b97";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/PinkNannies-Circle.svg
// module id = 17
// module chunks = 0